import {CreatedByProfileFormatter} from '../../../components/CreatedByProfileFormatter';
import {Price,} from '../types';
import {PlatformPropertyCard, TabbedComponent, TabComponentTab} from "@flexinet/ui-components";
import {PriceStatusBadge} from "./PriceStatusBadge.tsx";
import {
    Grid,
    Stack
} from "@mantine/core";
import {PriceDisplayBadge} from "./PriceDisplayBadge.tsx";
import { PriceProviderMappings } from '../components/PriceProviderMappings';


export const Profile = ({record}: { record: Price }) => {
    const properties = [
        {
            label: 'ID',
            value: record.id as string,
            span: 12,
        }, {
            label: 'Product',
            value: record.product?.name || record.productId as string,
            span: 12,
        }, {
            label: 'Price Status',
            value: <PriceStatusBadge record={record}/>,
            span: 12,
        }, {
            label: 'Pricing Model',
            value: record.pricingModel as string,
            span: 12,
        }, {
            label: 'Amount',
            value: <PriceDisplayBadge record={record}/>,
            span: 12,
        }, {
            label: 'Rate Plan',
            value: record.ratePlanId as string,
            span: 12,
        }];

    const properties1 = [
        {
            label: 'Recurring',
            value: record.recurringOption,
            span: 12,
        }, {
            label: 'Billing Period',
            value: record.billingPeriod,
            span: 12,
        }, {
            label: 'Description',
            value: record.description,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: 'UpdatePrice',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    const tabs = [
        {
            title: 'Price Details',
            component: (
                <Stack gap={'xl'}>
                    <PlatformPropertyCard properties={properties1}/>
                </Stack>
            )
        },
        {
            title: 'Provider Mappings',
            component: <PriceProviderMappings priceId={record.id} />
        }
    ] as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{
                base: 12,
                lg: 4
            }}>
                <Stack gap={'xl'}>
                    <PlatformPropertyCard properties={properties}/>
                    <PlatformPropertyCard properties={properties2}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{
                base: 12,
                lg: 8
            }}>
                <TabbedComponent tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );
};
